<template>
  <div>
    <fragment v-if="feeds && feeds.length">
      <div class="row">
        <div class="col-12 col-md-10 offset-md-1">
          <dashboard-notification v-for="notification in activeDashboardNotifications"
                                  :key="notification.id" :notification="notification" />
        </div>
      </div>

      <div class="row">
        <div v-if="analytics_enabled" class="col-12 col-md-10 offset-md-1">
          <radar-highlights />
        </div>

        <div class="col-12 col-md-10 offset-md-1">
          <podcast-index />
        </div>
      </div>
      <feed-url-modal />
    </fragment>
    <fragment v-else>
      <div class="col-12 col-md-10 offset-md-1">
        <basic-portlet title="Welcome to Timbre">
          <div class="empty-content-margin">
            <h5 class="text-center">
              To start using Timbre Features, we first need to create or import a {{ getFeedLabel(true) }}.
            </h5>
            <p class="text-center">
              Once you have added a podcast, revisit this dashboard to see useful information about your account.
            </p>
            <div class="podcast-buttons text-center mt-4">
              <a :href="create_feed_url" class="btn btn-ss-standout btn-icon-sm">
                <i class="la la-plus" /> Create my First {{ getFeedLabel(true) }}
              </a>
              <button class="btn btn-ss btn-icon-sm" @click="importFeed">
                <i class="la la-download" /> Import my Existing {{ getFeedLabel(true) }}
              </button>
            </div>
          </div>
        </basic-portlet>
      </div>
      <feed-url-modal :callback="modalCallback" />
    </fragment>
  </div>
</template>

<script>
import DashboardMixin from "VueMixins/DashboardMixin";
import FeedUrlModal from 'VuePartials/Feeds/FeedUrlModal';
import RadarHighlights from "VuePartials/Home/RadarHighlights.vue";
import FeedsModalsMixin from "VueMixins/Feeds/FeedsModalsMixin";

export default {
  components: {
    FeedUrlModal,
    RadarHighlights,
  },
  mixins: [DashboardMixin, FeedsModalsMixin],
  data() {
    return {
      create_feed_url: this.isPodcaster() ? '/podcast/create' : '/feed/create',
    };
  },
};
</script>
